
import React,{Component} from "react";
import $ from 'jquery';
import './Frame.scss'
import 'magnific-popup';
import '../../shared/_magnificPopup.scss'


var styles = 'body{color:red;}.u-isHidden {display: none;visibility: hidden;}';

localStorage.setItem('formComplete',false);

class Frame extends Component{
    constructor(props) {
        super(props);
        this.state = {show: true};
        let interval="";

        $('#eloqua-pop').magnificPopup({ 
          type: 'iframe',
          focus:"#field4",
          closeBtnInside:true,
          autoFocusLast: true,
          autoFocusLast: true,
          mainClass:'eloqua_pop',
          showCloseBtn:false,
          enableEscapeKey:false,
          closeOnBgClick:false,
          callbacks: {
            open:function(){
              $(".Panel__results a").attr('tabindex','-1');
              $(".Header__wrapper a").attr('tabindex','-1');
              $(".Button--2").attr('tabindex','-1');
              $(".Footer__content a").attr('tabindex','-1');
              interval = setInterval(() => {
                console.log('form complete?: ' + localStorage.getItem('formComplete'))
                if(localStorage.getItem('formComplete')=='true'){
                  let timerid = setTimeout(() => {
                    $('#eloqua-pop').magnificPopup('close');
                    }, 2500);
              }
              }, 1000);

            },
            close:function(){
              $(".Panel__results a").attr('tabindex','1');
              $(".Header__wrapper a").attr('tabindex','1');
              $(".Button--2").attr('tabindex','1');
              $(".Footer__content a").attr('tabindex','1');
              clearInterval(interval);

              document.getElementById("announcement").innerHTML="<p>Form was Sumbitted! Thank you for your submission.</p>"
              setTimeout(function() {
                $('.Results__subtitle--2').trigger('focus'); 
              },500)
            }
          } }
        );
        $('#eloqua-pop').click()
    }
    componentDidMount() {
      $('#eloqua-pop').click()
    }

    
    render(){
        return(
      
             <div className="frame_holder" >
             <div id="announcement" className="sr-only" aria-live="assertive"></div>

<a 
tabIndex={-1} aria-hidden="true"
href="FormsRepost/formsrepost.html" 
className="btn btn-white "
id="eloqua-pop" >
  <span >e</span></a>

        </div>
         )
    }

}


export default Frame;